/**
 * Slide Container Component
 * Provides consistent wrapper for content slides with title, progress bar, and navigation
 * Title slides use their own layout
 */

import React from 'react';
import { SlideNavigation } from './Navigation';
import { NavigationProps } from '../../types/slideTypes';

interface SlideContainerProps extends NavigationProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  showLogo?: boolean;
}

export const SlideContainer: React.FC<SlideContainerProps> = ({
  title,
  subtitle,
  children,
  currentSlide,
  totalSlides,
  onGoToSlide,
  showLogo = false,
}) => {
  return (
    <div className="h-full bg-white flex flex-col relative">
      {/* Main Content */}
      <div className="flex-1 p-4 pt-8 md:p-6 md:pt-10 lg:p-8 lg:pt-12 overflow-y-auto">
        <div className="max-w-7xl mx-auto">
          {/* Title and Separator */}
          <div className="mb-4 md:mb-6">
            <h1
              className="font-bold text-black"
              style={{ fontSize: 'clamp(1.75rem, 4vw, 2.25rem)' }}
            >
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-slate-600 mt-2">{subtitle}</p>
            )}
            <div className="w-full h-1 rounded mt-3 md:mt-4" style={{ backgroundColor: '#1e293b' }}></div>
          </div>

          {/* Body Content */}
          <div className="space-y-6">{children}</div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <SlideNavigation
        currentSlide={currentSlide}
        totalSlides={totalSlides}
        onGoToSlide={onGoToSlide}
      />
    </div>
  );
}
